import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { PATHS } from "util/appConstants";
import {
  selectCustomer,
  selectCustomerStatus,
  getCustomer,
  addCustomer,
} from "redux/slices/customerSlice";
import { getTours, selectTours } from "redux/slices/tourSlice";
import {
  getZipcodes,
  selectZipcodes,
  selectZipcodeStatus,
} from "redux/slices/zipcodeSlice";
import CustomerForm from "components/Customers/form";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import CustomersNavbar from "components/Masterbar/CustomersBar";
import { selectUser } from "redux/slices/userSlice";

const currentAction = "ADD";

const AddWithExistingCustomerData = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const loading = useSelector(selectCustomerStatus);
  const loadingZipcodes = useSelector(selectZipcodeStatus);
  const zipcodes = useSelector(selectZipcodes);
  let customer = useSelector(selectCustomer);
  const tours = useSelector(selectTours);
  const user = useSelector(selectUser);

  useEffect(() => {
    if (id && !loading) {
      dispatch(getCustomer(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(getTours());
  }, [dispatch]);

  useEffect(() => {
    if (!loadingZipcodes) {
      dispatch(getZipcodes());
    }
  }, []);

  const onSubmit = async (payload) => {
    await dispatch(addCustomer(payload)).then((res) =>
      res !== undefined ? history.push(PATHS.customers.root) : ""
    );
  };
  if (customer && user) {
    const { number, supplier_id, ...updatedCustomer } = customer;
    updatedCustomer.supplier_id = user.supplier_id;
    updatedCustomer.supplier_location_id = user.supplier_location_id;
    customer = updatedCustomer;
  }

  return (
    <>
      <Navbar />
      <CustomersNavbar />
      <LightLayout doublebar loading={loading || !customer}>
        <CustomerForm
          initialValues={customer}
          onSubmit={onSubmit}
          action={currentAction}
          tourList={tours}
          zipcodes={zipcodes}
        />
      </LightLayout>
    </>
  );
};
export default AddWithExistingCustomerData;
